// Golf Hustler header + hero (golfhustler build only). This IS the whole header
// + hero — one flat wide/short image (public/golfhustler-hero-full.png) with the
// nav baked in, shown full-bleed (width:100% / height:auto) so it stays a short
// wide banner and scales with the window. Transparent clickable hotspots are
// overlaid as PERCENTAGES of the image (so they stay aligned at every width),
// wired to the existing routes. YOUR GOLF + PICK A GAME render below (unchanged).
import { Link } from 'react-router-dom'

// % of the 1752×878 header/hero image (full GOLF HUSTLER, small gap above).
const HOT = {
  logo:    { l: 2.0,  t: 3,   w: 16.0, h: 17 },
  home:    { l: 29.0, t: 6,   w: 6.5,  h: 10 },
  history: { l: 38.5, t: 6,   w: 7.0,  h: 10 },
  season:  { l: 48.5, t: 6,   w: 6.5,  h: 10 },
  groups:  { l: 58.5, t: 6,   w: 6.5,  h: 10 },
  help:    { l: 69.0, t: 6,   w: 5.0,  h: 10 },
  profile: { l: 93.5, t: 5,   w: 5.0,  h: 12 },
}
const pos = (h) => ({ left: h.l + '%', top: h.t + '%', width: h.w + '%', height: h.h + '%' })

export default function HustlerHero() {
  const home = () => window.scrollTo({ top: 0, behavior: 'smooth' })
  return (
    <div className="hh-heroimg">
      <img src="/golfhustler-hero-v3.png" alt="Golf Hustler — Golf Game Central. Build your game. Play it on the course. Create your golf games and play them from the Golf Hustler app." />
      {/* Transparent clickable overlays wired to the real routes */}
      <button type="button" onClick={home} aria-label="Golf Hustler home" className="hh-hot" style={pos(HOT.logo)} />
      <button type="button" onClick={home} aria-label="Home" className="hh-hot" style={pos(HOT.home)} />
      <Link to="/admin/gg/history" aria-label="History" className="hh-hot" style={pos(HOT.history)} />
      <Link to="/admin/gg/season" aria-label="Season" className="hh-hot" style={pos(HOT.season)} />
      <Link to="/admin/gg/multigroup" aria-label="Groups" className="hh-hot" style={pos(HOT.groups)} />
      <Link to="/admin/gg/games" aria-label="Help" className="hh-hot" style={pos(HOT.help)} />
      <a href="#profile" onClick={(e) => e.preventDefault()} aria-label="Profile" className="hh-hot" style={pos(HOT.profile)} />
    </div>
  )
}
